// O pdfmake (~2 MB com as fontes) é carregado sob demanda: importá-lo no topo o coloca no
// bundle inicial de todo usuário, inclusive quem nunca gera relatório.

/** Recorte da API do pdfmake usado aqui — a biblioteca não publica tipos. */
interface PdfDocumento {
  docDefinition: { pageOrientation?: string };
  download(nomeArquivo: string): void;
}

interface PdfMake {
  vfs: unknown;
  createPdf(definicao: Record<string, unknown>): PdfDocumento;
}

let pdfMakeCarregado: Promise<PdfMake> | null = null;

const carregarPdfMake = (): Promise<PdfMake> => {
  if (!pdfMakeCarregado) {
    pdfMakeCarregado = Promise.all([
      // @ts-ignore — pdfmake não declara tipos
      import('pdfmake/build/pdfmake'),
      // @ts-ignore
      import('pdfmake/build/vfs_fonts')
    ])
      .then(([moduloPdfMake, moduloFontes]) => {
        const pdfMake = ((moduloPdfMake as { default?: PdfMake }).default ?? moduloPdfMake) as PdfMake;
        const fontes = ((moduloFontes as { default?: unknown }).default ?? moduloFontes) as {
          pdfMake?: { vfs: unknown };
          vfs?: unknown;
        };
        // O pacote expõe `vfs` na raiz ou sob `pdfMake`, conforme a versão.
        pdfMake.vfs = fontes.pdfMake?.vfs ?? fontes.vfs;
        return pdfMake;
      })
      .catch(erro => {
        // Sem limpar, uma falha de rede fica em cache e quebra todo clique seguinte.
        pdfMakeCarregado = null;
        throw erro;
      });
  }
  return pdfMakeCarregado;
};

export const generateReport = async (
  title: any,
  fields: Array<{ label: string; value: string }>,
  data: any,
  user: any,
  params: {
    orientation: 'LANDSCAPE' | 'PORTRAIT';
  } = { orientation: 'PORTRAIT' }
): Promise<void> => {
  const content: any = [{ text: title, style: 'header' }];

  const tableHeader = [{ text: '#', style: 'itemsTableHeader' }];
  for (const field of fields) {
    tableHeader.push({ text: field.label, style: 'itemsTableHeader' });
  }

  const items: any[] = [];

  data.forEach((d: any, index: number) => {
    const line = [{ text: index + 1, alignment: 'right' }];
    for (const field of fields) {
      line.push(d[field.value] || '');
    }
    items.push(line);
  });

  content.push('\n');
  content.push({
    style: 'itemsTable',
    table: {
      body: [tableHeader].concat(items)
    }
  });

  const now = new Date();

  const localeDate = `${now.toLocaleDateString()} ás ${now.toLocaleTimeString()}`;

  const pdfMake = await carregarPdfMake();
  const pdf = pdfMake.createPdf({
    content: content,
    footer: {
      text: `Gerado através do eCondos web, por ${user.firstName} ${user.lastName} em ${localeDate}.`,
      alignment: 'center'
    },
    styles: {
      header: {
        fontSize: 16,
        bold: true,
        margin: [0, 0, 0, 5]
      },
      itemsTable: {
        margin: [0, 5, 0, 0]
      },
      itemsTableHeader: {
        bold: true,
        fontSize: 9,
        color: 'black'
      }
    },
    defaultStyle: {
      fontSize: 9
    },
    pageSize: 'A4',
    pageMargins: [20, 20, 20, 30]
  });
  if (params && params.orientation) {
    pdf.docDefinition.pageOrientation = params.orientation.toLowerCase();
  }
  pdf.download(`${title}.pdf`);
};

export const generateCsv = (fields: Array<{ label: string; value: string }>, data: any) => {
  let csvContent = fields.map(f => f.label).join(';');
  csvContent += '\n';

  data.forEach((item: any) => {
    const line = [];
    for (const field of fields) {
      line.push(item[field.value]);
    }
    csvContent += line.join(';') + '\n';
  });

  const encodedUri = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csvContent);
  return encodedUri;
};
